const INSET = 0.02;
const MAX_TRIM = 0.12;

// Finds light/dark photo borders (mat, wall, frame edges) so mirrored tiles meet on painted pixels only.
export function detectCrop(img) {
  const fallback = [INSET, INSET, 1 - INSET, 1 - INSET];
  try {
    const s = Math.min(1, 240 / Math.max(img.width, img.height));
    const W = Math.max(8, Math.round(img.width * s));
    const H = Math.max(8, Math.round(img.height * s));
    const c = document.createElement("canvas");
    c.width = W;
    c.height = H;
    const g = c.getContext("2d", { willReadFrequently: true });
    g.drawImage(img, 0, 0, W, H);
    const d = g.getImageData(0, 0, W, H).data;
    const lum = (x, y) => {
      const i = (y * W + x) * 4;
      return (d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114) / 255;
    };
    const stats = (pts) => {
      let a = 0, b = 0;
      pts.forEach(([x, y]) => {
        const v = lum(x, y);
        a += v;
        b += v * v;
      });
      const m = a / pts.length;
      return { m, sd: Math.sqrt(Math.max(0, b / pts.length - m * m)) };
    };
    const inner = [];
    for (let y = Math.round(H * 0.2); y < H * 0.8; y += 3) for (let x = Math.round(W * 0.2); x < W * 0.8; x += 3) inner.push([x, y]);
    const mid = stats(inner).m;
    const isBorder = ({ m, sd }) => sd < 0.06 || (Math.abs(m - mid) > 0.2 && sd < 0.14) || m - mid > 0.18;
    const scan = (n, line) => {
      let k = 0;
      while (k < n * MAX_TRIM && isBorder(stats(line(k)))) k++;
      return k / n;
    };
    const row = (y) => Array.from({ length: W }, (_, x) => [x, y]);
    const col = (x) => Array.from({ length: H }, (_, y) => [x, y]);
    const top = scan(H, (k) => row(k));
    const bottom = scan(H, (k) => row(H - 1 - k));
    const left = scan(W, (k) => col(k));
    const right = scan(W, (k) => col(W - 1 - k));
    return [left + INSET, bottom + INSET, 1 - right - INSET, 1 - top - INSET];
  } catch {
    return fallback;
  }
}
